export const addresses = {
  nounsProvider:"0x6d4679C7e93C121Cf65Ed3388649428D013Afa24",
  fontLondrinaSolid:"0x3CfC7F5005cc25753ED113ed599E673EEA6b84aB",
  pnouns:"0xCa92CDF03ABfa9b806f36Dd0320d4C782ce50905",
}
